import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { APIURL } from "../../../Config";
import LoanDetails from "../../LoanDetails";
import { DownloadTableExcel } from "react-export-table-to-excel";

function OpenMarket() {
  const token = localStorage.getItem("token");

  const tableOpenMarket = React.useRef(null);
  const emailid = localStorage.getItem("emailId");
  const [data, setData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [month, setMonth] = useState(0);
  const [months, setMonths] = useState([]);
  const [month1, setMonth1] = useState(0);
  const [months1, setMonths1] = useState([]);
  const [keyName, setKeyName] = useState("mobile");
  const [searchInput, setSearchInput] = useState("");
  const [hide, setHide] = useState(false);
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    manageemployeeopen();
  }, []);
  const handleInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long", month1: "long" });

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const monthsArray = [];
    for (let i = 0; i < 3; i++) {
      const monthDate = new Date(currentYear, now.getMonth() - i, 1);
      const monthName = getMonthName(monthDate);
      monthsArray.push({
        name: `${monthName} ${currentYear}`,
        value: i.toString(),
      });
    }

    setMonths(monthsArray);
    setMonths1(monthsArray);
    setMonth("0");
    setMonth1("0");
  }, []);

  const manageemployeeopen = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/manageemployeeopen/${month1}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setData(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const manageemployeeopenStatus = (mobile, status) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/marketstatus`, {
        method: "POST",
        data: {
          mobile: mobile,
          status: status,
        },
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response.data);
        manageemployeeopen();
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const search = () => {
    setIsLoader(true);
    const data = { [keyName]: searchInput, status: month, ownerEmail: emailid };
    axios
      .request(`${APIURL}/searchdetails`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setData(response?.data);
        setHide(true);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Manage Employees
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  {showSearch ? (
                    <>
                      <div className="p-3 d-flex justify-content-start mt-3">
                        <button
                          className="btn btn-secondary"
                          style={{ width: "100px" }}
                          onClick={() => {
                            setShowSearch(false);
                          }}
                        >
                          Back
                        </button>
                      </div>
                      <div className="p-3 pt-2">
                        <LoanDetails lid={lid} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="p-0 d-flex flex-column flex-md-row justify-content-end align-items-center">
                        <div className="d-flex flex-grow-1">
                          <DownloadTableExcel
                            filename="OpenMarket"
                            sheet="users"
                            currentTableRef={tableOpenMarket.current}
                          >
                            <button
                              className="btn btn-success mb-3 mb-md-0"
                              style={{
                                width: "120px",
                                backgroundColor: "#66a725",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="d-flex flex-column flex-md-row align-items-center">
                          <div>
                            <select
                              className="form-select mb-md-0"
                              id="lang"
                              onChange={(e) => setMonth(e.target.value)}
                              value={month}
                              style={{ width: "120px" }}
                            >
                              {months.map(({ name, value }) => (
                                <option key={value} value={value}>
                                  {name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <select
                            className="form-select mx-md-2 mb-2 mb-md-0"
                            id="lang"
                            onChange={(e) => setKeyName(e.target.value)}
                            value={keyName}
                            style={{ width: "130px" }}
                          >
                            <option value="mobile">Mobile No.</option>
                            <option value="lid">Loan id</option>
                            <option value="name">Name</option>
                          </select>
                          <input
                            className="form-control"
                            style={{
                              height: "38px",
                              width: "150px",
                              background: "#fff",
                            }}
                            type="text"
                            placeholder="Search"
                            value={searchInput}
                            onChange={handleInputChange}
                          />
                          <button
                            className="btn btn-success ml-md-2 mt-2 mt-md-0"
                            style={{ background: "#66a725", color: "#fff" }}
                            onClick={search}
                          >
                            Search
                          </button>
                        </div>
                      </div>

                      <div className="d-flex mt-2 flex-column flex-md-row align-items-center align-items-md-center justify-content-end">
                        <div className="mt-2 mt-md-0 d-flex align-items-start align-items-md-center">
                          <select
                            className="form-select mx-md-2 mb-md-0"
                            id="lang"
                            onChange={(e) => setMonth1(e.target.value)}
                            value={month1}
                          >
                            {months1.map(({ name, value }) => (
                              <option key={value} value={value}>
                                {name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="ml-md-2">
                          <button
                            className="btn btn-success border mt-2 mt-md-0"
                            style={{ background: "#66a725", color: "#fff" }}
                            onClick={manageemployeeopen}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>Name </th>
                                <th style={{ textAlign: "center" }}>LID</th>
                                <th style={{ textAlign: "center" }}>Mobile</th>
                                <th style={{ textAlign: "center" }}>
                                  Limit assigned
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Limit used
                                </th>
                                <th style={{ textAlign: "center" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{item.name}</td>
                                  <td
                                    style={{
                                      color: "blue",
                                      cursor: "pointer",
                                      textAlign: "center",
                                    }}
                                    onClick={() => {
                                      if (item.loanid) {
                                        setLid(item.loanid);
                                        setShowSearch(true);
                                      }
                                    }}
                                  >
                                    {item.loanid}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.mobile}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.limitassigned}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.limitused}
                                  </td>
                                  <td style={{ width: "120px" }}>
                                    <div className="d-flex">
                                      <button
                                        className={`btn ${
                                          item?.accountstatus === "ACTIVE"
                                            ? "btn-success"
                                            : "btn-outline-success"
                                        }`}
                                        onClick={() =>
                                          manageemployeeopenStatus(
                                            item.mobile,
                                            "ACTIVE"
                                          )
                                        }
                                        disabled={
                                          item?.accountstatus === "ACTIVE"
                                        }
                                      >
                                        Active
                                      </button>
                                      <button
                                        className={`btn ml-2 ${
                                          item?.accountstatus === "INACTIVE"
                                            ? "btn-danger"
                                            : "btn-outline-danger"
                                        }`}
                                        onClick={() =>
                                          manageemployeeopenStatus(
                                            item.mobile,
                                            "INACTIVE"
                                          )
                                        }
                                        disabled={
                                          item?.accountstatus === "INACTIVE"
                                        }
                                      >
                                        Deactive
                                      </button>
                                    </div>
                                  </td>{" "}
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          {/* {helpline && helpline.length !== 0 && (
                    <Pagination
                      showPrePage={showPrePage}
                      onPaginationChange={onPaginationChange}
                      total={helpline.length}
                    />
                  )} */}
                        </div>
                      )}
                    </>
                  )}
                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableOpenMarket}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Name </th>
                        <th style={{ textAlign: "center" }}>LID</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>Limit assigned</th>
                        <th style={{ textAlign: "center" }}>Limit used</th>
                        <th style={{ textAlign: "center" }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item.name}</td>
                          <td
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                            onClick={() => {
                              if (item.loanid) {
                                setLid(item.loanid);
                                setShowSearch(true);
                              }
                            }}
                          >
                            {item.loanid}
                          </td>
                          <td style={{ textAlign: "center" }}>{item.mobile}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.limitassigned}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item?.limitused}
                          </td>
                          <td style={{ width: "120px" }}>
                            <div className="d-flex">
                              <button
                                className={`btn ${
                                  item?.accountstatus === "ACTIVE"
                                    ? "btn-success"
                                    : "btn-outline-success"
                                }`}
                                onClick={() =>
                                  manageemployeeopenStatus(
                                    item.mobile,
                                    "ACTIVE"
                                  )
                                }
                                disabled={item?.accountstatus === "ACTIVE"}
                              >
                                Active
                              </button>
                              <button
                                className={`btn ml-2 ${
                                  item?.accountstatus === "INACTIVE"
                                    ? "btn-danger"
                                    : "btn-outline-danger"
                                }`}
                                onClick={() =>
                                  manageemployeeopenStatus(
                                    item.mobile,
                                    "INACTIVE"
                                  )
                                }
                                disabled={item?.accountstatus === "INACTIVE"}
                              >
                                Deactive
                              </button>
                            </div>
                          </td>{" "}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpenMarket;
